export const FileUploadStatus = Object.freeze({
	PENDING: 'PENDING',
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED',
	COMPLETED_FINALIZING: 'COMPLETED_FINALIZING',
	ERROR: 'ERROR',
	CANCELLED: 'CANCELLED',
	PAUSED: 'PAUSED',
})
